"use client"

import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"

interface ProjectFilterProps {
    categories: string[]
    activeCategory: string
    onCategoryChange: (category: string) => void
}

export function ProjectFilter({ categories, activeCategory, onCategoryChange }: ProjectFilterProps) {
    return (
        <div className="flex flex-wrap gap-2 justify-center mb-12">
            {categories.map((category) => (
                <motion.button
                    key={category}
                    onClick={() => onCategoryChange(category)}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className={`px-6 py-2 rounded-full text-sm font-medium transition-all ${activeCategory === category
                            ? "bg-primary text-primary-foreground shadow-lg shadow-primary/25"
                            : "bg-muted/10 border border-border hover:border-primary/50 hover:bg-primary/10"
                        }`}
                >
                    {category}
                </motion.button>
            ))}
        </div>
    )
}
